import { render, staticRenderFns } from "./CurrencyMenu.vue?vue&type=template&id=943c7c6a&"
import script from "./CurrencyMenu.vue?vue&type=script&lang=js&"
export * from "./CurrencyMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports